import { type ApiResponse } from '@type/api'
import { axiosProxy } from '@utils/axios'

import { type Api } from './types'

const list = (params: Api.ListParams) => axiosProxy.get<ApiResponse<Api.ListData>>('/fulfillment', { params })

const cityOptions = (params: Api.CityOptionsParams) =>
  axiosProxy.get<ApiResponse<Api.CityOptionsData>>('/fulfillment/options/cities', { params })

const city = (slug: string) => axiosProxy.get<ApiResponse<Api.CityData>>(`/fulfillment/city/${slug}`)

const serviceCityOptions = (params: Api.CityOptionsParams) =>
  axiosProxy.get<ApiResponse<Api.ServiceCityOptionsData>>('/fulfillment/options/service-cities', { params })

/** Справочник услуг: из него владелец собирает прайс. Единицы измерения здесь пока не приходят. */
const serviceOptions = (params: Api.CityOptionsParams) =>
  axiosProxy.get<ApiResponse<Api.ServiceOptionsData>>('/fulfillment/options/services', { params })

const categoryOptions = (params: Api.CityOptionsParams) =>
  axiosProxy.get<ApiResponse<Api.CategoryOptionsData>>('/fulfillment/options/categories', { params })

const warehouseOptions = (params: Api.CityOptionsParams) =>
  axiosProxy.get<ApiResponse<Api.WarehouseOptionsData>>('/fulfillment/options/warehouses/wildberries', { params })

/** Склады Ozon: справочник ведётся у нас вручную, числового кода у складов нет. */
const ozonWarehouseOptions = (params: Api.CityOptionsParams) =>
  axiosProxy.get<ApiResponse<Api.MarketplaceWarehouseOptionsData>>('/fulfillment/options/warehouses/ozon', { params })

const statEvent = (slug: string, event: Api.StatEvent) =>
  axiosProxy.post<ApiResponse<{ counted: boolean }>>(`/fulfillment/${slug}/stat`, { event })

const contact = (slug: string, type: Api.ContactType) =>
  axiosProxy.get<ApiResponse<Api.ContactData>>(`/fulfillment/${slug}/contact/${type}`)

const claim = (slug: string, request: Api.ClaimRequest) =>
  axiosProxy.post<ApiResponse<{ claim_id: string }>>(`/fulfillment/${slug}/claim`, request)

/**
 * Отзыв уходит на проверку администратору, поэтому сразу на карточке его не видно никому,
 * кроме автора. В ответе приходит обновлённый список — перечитывать карточку не нужно.
 */
const saveReview = (slug: string, request: Api.ReviewRequest) =>
  axiosProxy.post<ApiResponse<Api.ReviewListData>>(`/fulfillment/${slug}/review`, request)

const deleteReview = (slug: string) => axiosProxy.delete<ApiResponse<Api.ReviewListData>>(`/fulfillment/${slug}/review`)

/** Ответ владельца карточки на опубликованный отзыв. */
const replyToReview = (slug: string, id: string, request: Api.ReviewReplyRequest) =>
  axiosProxy.post<ApiResponse<Api.ReviewListData>>(`/fulfillment/${slug}/review/${id}/reply`, request)

const myList = () => axiosProxy.get<ApiResponse<Api.MyListData>>('/fulfillment/my/list')

const owner = (slug: string) => axiosProxy.get<ApiResponse<Api.OwnerData>>(`/fulfillment/${slug}/edit`)
const detail = (slug: string) => axiosProxy.get<ApiResponse<Api.DetailData>>(`/fulfillment/${slug}`)
/**
 * Сохранение ждёт дольше обычного: при указанной ссылке на Яндекс Карты сервер прямо в этом запросе
 * забирает оттуда оценки, отзывы и фотографии, чтобы карточка открылась уже заполненной.
 */
const saveConfig = { headers: { 'X-Evirma-Skip-Retry': '1' }, timeout: 30000 }
const create = (request: Api.SaveRequest) =>
  axiosProxy.post<ApiResponse<Api.OwnerData>>('/fulfillment/create', request, saveConfig)
const update = (id: string, request: Api.SaveRequest) =>
  axiosProxy.post<ApiResponse<Api.OwnerData>>(`/fulfillment/${id}/edit`, request, saveConfig)

export const api = {
  list,
  city,
  cityOptions,
  serviceCityOptions,
  categoryOptions,
  serviceOptions,
  warehouseOptions,
  ozonWarehouseOptions,
  owner,
  myList,
  detail,
  contact,
  claim,
  saveReview,
  deleteReview,
  replyToReview,
  statEvent,
  create,
  update,
}
